export class SgKdConstants {

  /** 業務日付区分 */
  static readonly BUSINESS_DATE_KBN = "PCZZ0001";

  /**
   * 文字列
   */
  static readonly STR = {
    /** 空文字 */
    EMPTY: "",
    /** ハイフン */
    HYPHEN: "-",
    /** 全角 */
    ZEN: "　",
  };

  /**
   * 処理結果コード
   */
  static readonly RESULT_CODE = {
    /** 正常 */
    NORMAL_END: "0",
    /** 異常 */
    ABNORMAL_END: "9",
  };

  /**
   * 画面遷移パス
   */
  static readonly PATH = {
    /** 【共通】作業管理メニュー画面 */
    MANAGE_MENU: "/sgkz001d/",
    /** 【共通】完了画面 */
    COMPLETE: "/sgkz003d/"
  };

  /**
   * 受付基盤画面遷移情報
   */
  static readonly SGKA_PATH = {
    /** ベースURL */
    BASE_URL: "https://xxxxxxxx",
    /** 固定URL(Sandbox)
     */
    FIXED_URL: "--cisdev1.sandbox.lightning.force.com",
    /** 固定URL（本番環境） */
    // FIXED_URL: "lightning.force.com",
    /** リダイレクト用ページ */
    REDIRECR_PAGE: "/lightning/n/tab_sgkd010",
    /** パラメタ */
    PARAM: '`?c__${key}=${value}`'
  };

  /**
   * フラグ
   */
  static readonly FLG = {
    /** ON */
    ON: "1",
    /** OFF */
    OFF: "0",
  };

  /**
   * メッセージ
   */
  static readonly MESSAGE = {
    /** インフォ */
    INFO: {
      /** メッセージクラス */
      MESSAGE_CLS: "mat-card-background-primary",
      /** アイコン */
      ICON: "done",
      /** アイコンクラス */
      ICON_CLS: "mat-icon-color-primary",
    },
    /** エラー */
    ERROR: {
      /** メッセージクラス */
      MESSAGE_CLS: "mat-card-background-error",
      /** アイコン */
      ICON: "cancel",
      /** アイコンクラス */
      ICON_CLS: "mat-icon-color-error",
    },
    /** ワーニング */
    WARN: {
      /** メッセージクラス */
      MESSAGE_CLS: "mat-card-background-warning",
      /** アイコン */
      ICON: "warning",
      /** アイコンクラス */
      ICON_CLS: "mat-icon-color-warning",
    }
  };

  /**
   * コード
   */
  static readonly CODE = {

    /** 支払方法登録方法区分 */
    PAY_METHOD_REG_MTD_DIV: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200270",
      /** ユーザコード */
      USER_CODE: {
        /** オンライン */
        ONLINE: "1",
      }
    },

    /** 預金種別 */
    DPTCLSFY: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C000361"
    },

    /** 支払方法 */
    PAYMETHOD: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C000919",
      /** ユーザコード */
      USER_CODE: {
        /** ＣＶＳ払込票 */
        CVS: "1",
        /** 口座振替 */
        KOUZA: "2",
        /** 口座振替（ゆうちょ） */
        KOUZA_Y: "3",
        /** クレジット */
        CRD: "4",
        /** 請求書払い */
        SEIKYU: "5",
        /** 特定払込票 */
        TOKUTEI: "C",
        /** ＳＭＳ決済 */
        SMS: "D",
      }
    },

    /** 受取方法 */
    RECIV_METHOD: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C009160"
    },

    /** クレジット企業コード */
    CRD_COM_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C014020"
    },

    /** 申込書送付ステータスコード */
    SRNDOC_SEND_STS_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200130",
      /** ユーザコード */
      USER_CODE: {
        /** 受付 */
        ACEPT: "0"
      }
    },

    /** 申込書種別コード */
    SRNDOC_CLSFY_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200140",
      /** ユーザコード */
      USER_CODE: {
        /** 口振 */
        KOHURI: "01"
      }
    },

    /** 申込書種別コード */
    MOSHIKOMI_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200140"
    },

    /** 口振不備理由種別コード */
    REQDOC_FUBI_KIND_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200820",
      /** ユーザコード */
      USER_CODE: {
        /** SG業務不備 */
        SG_BIZ_FUBI: "A3",
      }  
    },

    /** 口振不備理由コード */
    REQDOC_FUBI_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200840",
      USER_CODE: {
        /** 契約者名相違 */
        CUST_NAME_MISS: "23",
      }  
    },

    /** クレ不備理由種別コード */
    CARD_FUBI_KIND_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200830",
      USER_CODE: {
        /** SG業務不備 */
        SG_BIZ_FUBI: "B3"
      }  
    },

    /** クレ不備理由コード */
    CARD_FUBI_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200850",
      USER_CODE: {
        /** 契約者名相違 */
        NAMR_MISS: "11"
      }  
    },

    /** 会社コード */
    COM_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S900025"
    },

    /** 請求区分 */
    CLAIM_DIV: {
      /** 口座振替 */
      KOHURI: '02'
    },

    /** 請求ステータス */
    CLAIM_STS: {
      /** 返却中 */
      REQRET: '03'
    },
  
    /** 口振翌月請求区分コード */
    KOHURI_NMCDIV: {
      /** 当月口座振替 */
      TOUGETSU: '0'
    },

    /** 受付状態 */
    ACEPT_STATE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200870",
      /** ユーザコード */
      USER_CODE: {
        /** 不備あり */
        FUBI: '1',
        /** 完了 */
        DONE: '2'
      }
    },
  
  };

  /** コード_取得対象テーブル区分_請求先 */
  public static readonly CODE_SHTKTARGETTBLDIV_SEIKYUSAKI: string = "1";
  /** コード_取得対象テーブル区分_契約先 */
  public static readonly CODE_SHTKTARGETTBLDIV_KEIYAKUSAKI: string = "3";
  /** コード_取得対象テーブル区分_供給先 */
  public static readonly CODE_SHTKTARGETTBLDIV_KYOKYUSAKI: string = "4";
  /** コード_参照先テーブル区分_1 */
  public static readonly CODE_REFBYTBLDIV_1: string = "1";
  /** コード_参照先テーブル区分_2 */
  public static readonly CODE_REFBYTBLDIV_2: string = "2";
  /** コード_参照先テーブル区分_3 */
  public static readonly CODE_REFBYTBLDIV_3: string = "3";

  /**
   * 支払方法変更画面
   */
  static readonly SGKD002D = {

    /** 画面ID */
    GAMEN_ID: "SGKD002D",
    /** 最大長 */
    MAX_LENGTH: {
      /** 口座名義（漢字） */
      KOUHURI_ACT_KNJ: 24,
      /** 口座名義（カナ） */
      MEIGI_KANA: 30,
      /** 金融機関コード */
      EXT_BANKFC_CODE: 4,
      /** 支店コード */
      EXT_BRANCH_CODE: 3,
      /** 口座番号 */
      KOUZA_NO: 7,
      /** カード名義（カナ） */
      CARD_MAIGI_KANA: 30,
      /** DBキー */
      CRD_LINK_KEY: 16,
      /** 携帯電話番号 */
      CELLPHONENUMBER: 13,
    },
  };

  /**
   * 口座振替依頼返却内訳表出力画面
   */
  static readonly SGKD010D = {

    /** 最大長 */
    MAX_LENGTH: {
      /** 金融機関コード */
      EXT_BANKFC_CODE: 4
    },
  };

  /**
   * 宛名印刷登録画面
   */
  static readonly SGKD019D = {

    /** 最大長 */
    MAX_LENGTH: {
      /** 請求契約番号 */
      CLAIM_CTR_NO: 10,
      /** 供給地点特定番号(電気) */
      SUPPNT_SPNO_D: 22,
      /** 供給地点特定番号(ガス) */
      SUPPNT_SPNO_G: 17,
      /** 郵便番号 */
      POST_NO: 8,
      /** 都道府県 */
      PFC_ANAME: 5,
      /** 行政市区 */
      ADMNCWNM: 36,
      /** 行政町名 */
      ADMNTNM: 36,
      /** 丁目 */
      CHOME: 36,
      /** 番地・号 */
      BUILDING_NUMBER: 50,
      /** 住宅・号棟漢字名 */
      VISIT_SUPADR: 50,
      /** 屋号・業種漢字名 */
      VISIT_YAGOU: 30,
      /** 送付先宛名 */
      SENDTO_ADDRESS: 50,
      /** 発行元 - 住所 */
      HAKKOMOTO_ADDR: 50,
      /** 発行元 - 問い合わせ窓口 */
      CONTACT_MADOGUCHI: 30,
      /** 電話番号 */
      TEL_NO: 12,
    },
  };

  /**
   * 口座振替・クレジット申込受付画面
   */
  static readonly SGKD020D = {

    /** 画面ID */
    GAMEN_ID: "SGKD020D",
    /** 最大長 */
    MAX_LENGTH: {
      /** 契約番号 */
      CTR_VISIT_NO: 10,
      /** お客様記入番号 */
      VISIT_KINYU_NO:15,
      /** 口座名義（漢字） */
      KOUHURI_ACT_KNJ: 24,
      /** 口座名義（カナ） */
      MEIGI_KANA: 30,
      /** 金融機関コード */
      BANKFC_CODE: 4,
      /** 金融機関名 */
      BANKFC_MEI: 20,
      /** 支店コード */
      BRANCH_CODE: 3,
      /** 支店名 */
      BRNCNM: 20,
      /** 預金種別 */
      DPT_CLSFY: 6,
      /** 口座番号 */
      KOUZA_NO: 7,
      /** 通帳記号  */
      PBOOK_KIGO: 3,
      /** 通帳番号  */
      PBOOK_NO: 8,
      /** クレジットカード名義(カナ) */
      CRD_KANA_NAME: 30,
      /** クレジット企業コード */
      CRD_CO_CODE: 5,
      /** クレジット企業名 */
      CRD_CO_NM: 20,
      /** DBキー */
      CRD_DB_KEY: 16,
      /** 預金者名義の相違 */
      DPTPRS_MEIGI_DIFF: 150,
      /** その他不備理由 */
      ETC_HUBIRSN: 150,
      /** ご契約者名 */
      CTRER_MEI: 50,
      /** 郵便番号 */
      POST_NO: 8,
      /** 都道府県名 */
      PREFECTUREA_NAME: 5,
      /** 行政市区名 */
      ADMINISTR_ATIVECITY_WARD_NAME: 36,
      /** 町名 */
      CHONAME: 36,
      /** 丁目 */
      CHOME: 50,
      /** 番地・号 */
      BUILDING_NUMBER: 50,
      /** 建物名 */
      VISIT_SUPADRA_NAME: 50,
      /** 目標・部屋番号 */
      VISIT_YAGOUA_NAME: 50,
      /** 備考欄 */
      REMARKS: 150      
    },
    /** 最小長 */
    MIN_LENGTH: {
      /** 金融機関コード */
      BANKFC_CODE: 4,
      /** 支店コード */
      BRANCH_CODE: 3,
    },
    /** 支払方法 */
    PAYMETHOD: {
      KOUZA : "1",
      CRD : "2"
    },  
  };

  /**
   * パターン
   */
  static readonly PATTERN = {
    /** 半角数値 */
    HAN_NUM: /\d+/,
    /** 電話番号 */
    TEL_NO: /(\d|-)+/,
    /** 郵便番号 */
    POST_NO: /^\d{3}-?\d{4}$/,
    /** 全角カナ(全角スペース含) */
    ZEN_KANA: /[ァ-ヶー　]+/,
    /** 供給地点特定番号 */
    SUPPNT_SPNO: /^\d{17}(\d{5})?$/
  }
}
